
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/partner/[permalink]",
      function () {
        return require("private-next-pages/discover/partner/[permalink].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/partner/[permalink]"])
      });
    }
  